import LeadsTipy from "./LeadsTipy";

export default LeadsTipy;
